export const trackEvent = (action, category, extra = {}) => {
  if (!window.gtag) {
    console.warn('Google Analytics is not initialized.');
    return;
  }

  window.gtag('event', action, {
    event_category: category,
    ...extra
  });
};

export const MAP_SEARCH = 'map_search';
export const LOCATION_SEARCH = 'location_search';
export const KEYWORD_SEARCH = 'keyword_search';
export const AI_SERACH = 'ai_search';
export const DATASETS = 'datasets';
export const DOWNLOAD_REPORT = 'download_report';
export const NAVIX_SEARCH = 'Navix Search';

